function loadImageElement(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Failed to load image for JPEG conversion"));
    img.src = src;
  });
}

function canvasToJpegDataUrl(img: HTMLImageElement, quality = 0.92): string {
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Canvas not available");
  }
  ctx.drawImage(img, 0, 0);
  return canvas.toDataURL("image/jpeg", quality);
}

/** Convert any browser-decodable image file to a JPEG data URL. */
export async function fileToJpegDataUrl(file: File): Promise<string> {
  const objectUrl = URL.createObjectURL(file);
  try {
    const img = await loadImageElement(objectUrl);
    return canvasToJpegDataUrl(img);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

/** Re-encode an existing data URL as JPEG (e.g. PNG data URLs from FileReader). */
export async function dataUrlToJpegDataUrl(dataUrl: string): Promise<string> {
  const img = await loadImageElement(dataUrl);
  return canvasToJpegDataUrl(img);
}
